/** Stable leave-reason keys (PDF SCHAL-701). Keep in sync with backend/src/types/gameLeave.ts */
export const LEAVE_REASON_OPTIONS = [
  { key: "personal_social", label: "Personal / Social" },
  { key: "work", label: "Work related" },
  { key: "injury", label: "Injury" },
  { key: "weather", label: "Weather" },
  { key: "joined_in_error", label: "Joined in error" },
  { key: "dislike_tee_time", label: "Don't like tee time" },
  { key: "dislike_players", label: "Don't like players" },
  { key: "other", label: "Other reason &/or leave message" },
] as const;

export type LeaveReasonKey = typeof LEAVE_REASON_OPTIONS[number]["key"];

/** Includes organiser-only keys not shown on the player leave dialog. */
export const LEAVE_REASON_LABELS: Record<string, string> = {
  ...Object.fromEntries(LEAVE_REASON_OPTIONS.map(o => [o.key, o.label])),
  organiser_removed: "Removed by admin",
};

export const MAX_LEAVE_MESSAGE_LENGTH = 500;

export interface LeaveGamePayload {
  reasons: LeaveReasonKey[];
  message?: string;
  requestId: string;
}
